
import { useState, useCallback } from 'react';
import { useAuth } from './useAuth';
import { apiService } from '../services/apiService';

// Helper function to convert file to base64
const fileToBase64 = (file) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      // Extract base64 data from data URL (remove "data:image/jpeg;base64," prefix)
      const base64 = reader.result.split(',')[1];
      resolve(base64);
    };
    reader.onerror = error => reject(error);
  });
};

export function useApi() {
  const authCtx = useAuth();

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  // Memoize getAuthHeader to prevent reference changes
  const getAuthHeader = useCallback(async () => {
    // Get token from localStorage instead of Firebase user
    const token = localStorage.getItem('authToken');
    if (!token) {
      throw new Error('No authentication token found');
    }
    return `Bearer ${token}`;
  }, []);



  // Memoize fetchWithAuth to prevent reference changes
  const fetchWithAuth = useCallback(async (endpoint, options = {}) => {
    try {
      setLoading(true);
      setError(null);
      
      // Use apiService for the request
      let response;
      if (options.method === 'POST') {
        // If body is already a string, parse it back to object to avoid double JSON.stringify
        console.log('🔍 fetchWithAuth POST - options.body:', options.body);
        console.log('🔍 fetchWithAuth POST - typeof options.body:', typeof options.body);
        const bodyData = typeof options.body === 'string' ? JSON.parse(options.body) : options.body;
        console.log('🔍 fetchWithAuth POST - endpoint:', endpoint, 'bodyData:', bodyData);
        response = await apiService.post(endpoint, bodyData);
        // response = await res.json();
      } else if (options.method === 'PUT') {
        const bodyData = typeof options.body === 'string' ? JSON.parse(options.body) : options.body;
        console.log('🔍 fetchWithAuth PUT - endpoint:', endpoint, 'bodyData:', bodyData);
        console.log('🔍 fetchWithAuth PUT - profileImageUrl in bodyData:', bodyData.profileImageUrl);
        console.log('🔍 fetchWithAuth PUT - profileImageUrl type:', typeof bodyData.profileImageUrl);
        response = await apiService.put(endpoint, bodyData);
        // response = await res.json();
      } else if (options.method === 'DELETE') {
        response = await apiService.delete(endpoint);
        // response = await res.json();
      } else {
        response = await apiService.get(endpoint);
        // response = await res.json();
      }
      
      // Handle Response objects from apiService
      if (response instanceof Response) {
        if (!response.ok) {
          const errorData = await response.json().catch(() => ({}));
          throw new Error(errorData.error || errorData.message || `HTTP ${response.status}: ${response.statusText}`);
        }
        return await response.json();
      }
      
      // Handle direct data responses
      return response.data || response;
    } catch (err) {
      console.error(`API Error (${endpoint}):`, err);
      setError(err.message);
      throw err;
    } finally {
      setLoading(false);
    }
  }, []);


  const sendEvaluationGatePassReminder = useCallback(async () => {
    try {
      const result = await apiService.GatePassReminder();
      console.log('🔍 GatePassReminde result:', result)
        return result;
    } catch (err) {
      console.error('Error in GatePassReminde:', err);
      throw new Error(err.message || 'Failed to send GatePassReminde');
    }
  }, [fetchWithAuth]);

  const sendInspectionReminder = useCallback(async () => {
    try {
      const result = await apiService.InspectionReminder();
      console.log('🔍 InspectionReminder result:', result

        )
        return result;
    } catch (err) {
      console.error('Error in InspectionReminder:', err);
      throw new Error(err.message || 'Failed to send InspectionReminder');

    }
  }, [fetchWithAuth]);

  const sendAuctionCloseAlert = useCallback(async () => {
    try {
      const result = await apiService.AuctionCloseAlert();
      console.log('🔍 AuctionCloseAlert result:', result

        )
        return result;
    } catch (err) {
      console.error('Error in AuctionCloseAlert:', err);
      throw new Error(err.message || 'Failed to send AuctionCloseAlert');
    }
  }, [fetchWithAuth]);

  const sendAuctionPaymentRequest = useCallback(async () => {
    try {
      const result = await apiService.AuctionPaymentRequest();
      console.log('🔍 AuctionPaymentRequest result:', result
        )

        return result;
    } catch (err) {
      console.error('Error in AuctionPaymentRequest:', err);
      throw new Error(err.message || 'Failed to send AuctionPaymentRequest');
    }
  }, [fetchWithAuth]);

  
  const sendCarPickupReminder = useCallback(async () => {
    try {
      const result = await apiService.CarPickupReminder();
      console.log('🔍 CarPickupReminder result:', result
        )
        return result;
    } catch (err) {
      console.error('Error in CarPickupReminder:', err);
      throw new Error(err.message || 'Failed to send CarPickupReminder');
    }
  }, [fetchWithAuth]);

  const sendDeliveryReminder = useCallback(async () => {
    try {
      const result = await apiService.DeliveryReminder();
      console.log('🔍 DeliveryReminder result:', result
        )
        return result;
    } catch (err) {
      console.error('Error in DeliveryReminder:', err);
      throw new Error(err.message || 'Failed to send DeliveryReminder');
    }
  }, [fetchWithAuth]);

  const sendKycReminder = useCallback(async () => {
    try {
      const result = await apiService.KycReminder();
      console.log('🔍 KycReminder result:', result
        )
        return result;
    } catch (err) {
      console.error('Error in KycReminder:', err);
      throw new Error(err.message || 'Failed to send KycReminder');
    }
  }, [fetchWithAuth]);

  
  const LoginDealer = useCallback(async (dealerData) => {
    try {
      const result = await apiService.LoginDealer(dealerData);
      console.log('🔍 LoginDealer result:', result);
      return result;
    } catch (err) {
      console.error('Error in LoginDealer:', err);
      throw new Error(err.message || 'Failed to LoginDealer');
    }
  }, [fetchWithAuth]);


  // REMOVED: SendOTPDealer - replaced by new OTP module
  // const SendOTPDealer = useCallback(async (dealerData) => {
  //   try {
  //     const result = await apiService.SendOTPDealer(dealerData);
  //     console.log('🔍 SendOTPDealer result:', result);
  //     return result;
  //   } catch (err) {
  //     console.error('Error in LoginDealer:', err);
  //     throw new Error(err.message || 'Failed to LoginDealer');
  //   }
  // }, [fetchWithAuth]);

  


  
  const getUsers = useCallback(async () => {
    try {
      const result = await fetchWithAuth('getUsersList');
      if (!result) {
        throw new Error('No data received from server');
      }
      console.log('🔍 useApi getUsers - Raw result:', result);
      console.log('🔍 useApi getUsers - First user roles:', result[0]?.roles);
      return result;
    } catch (err) {
      console.error('Error in getUsers:', err);
      throw new Error(err.message || 'Failed to fetch users');
    }
  }, [fetchWithAuth]);

  const getDealers = useCallback(async () => {
    try {
      const result = await fetchWithAuth('getDealerList');
      if (!result) {
        throw new Error('No data received from server');
      }
      return result;
    } catch (err) {
      console.error('Error in Dealer:', err);
      throw new Error(err.message || 'Failed to fetch users');
    }
  }, [fetchWithAuth]);

  

  const getOrganizations = useCallback(async () => {
    try {
      const result = await fetchWithAuth('getOrganizationsList');
      if (!result) {
        throw new Error('No data received from server');
      }
      // Backend returns { organizations: [...] }, so extract the organizations array
      return result.organizations || result;
    } catch (err) {
      console.error('Error in getOrganizations:', err);
      throw new Error(err.message || 'Failed to fetch organizations');
    }
  }, [fetchWithAuth]);

  const getRoles = useCallback(async () => {
    try {
      const result = await apiService.getRoles();
      if (!result) {
        throw new Error('No data received from server');
      }
      return result;
    } catch (err) {
      console.error('Error in getRoles:', err);
      throw new Error(err.message || 'Failed to fetch roles');
    }
}, []);

  const getCities = useCallback(async () => {
    try {
      const result = await fetchWithAuth('getCitiesList');
      if (!result) {
        throw new Error('No data received from server');
      }
      return result;
    } catch (err) {
      console.error('Error in getCities:', err);
      throw new Error(err.message || 'Failed to fetch cities');
    }
  }, [fetchWithAuth]);

  const getBDMCityMappings = useCallback(async () => {
    try {
      const result = await fetchWithAuth('getBDMCityMappings');
      if (!result) {
        throw new Error('No data received from server');
      }
      return result;
    } catch (err) {
      console.error('Error in getBDMCityMappings:', err);
      throw new Error(err.message || 'Failed to fetch BDM-City mappings');
    }
  }, [fetchWithAuth]);

  const createBDMCityMapping = useCallback(async (bdmId, cityIds, role) => {
    try {
      const result = await fetchWithAuth('createBDMCityMapping', {
        method: 'POST',
        body: JSON.stringify({ bdmId, cityIds, role })
      });
      return result;
    } catch (err) {
      console.error('Error in createBDMCityMapping:', err);
      throw new Error(err.message || 'Failed to create BDM-City mapping');
    }
  }, [fetchWithAuth]);

  const updateBDMCityMapping = useCallback(async (mappingId, bdmId, cityIds) => {
    try {
      const result = await fetchWithAuth('updateBDMCityMapping', {
        method: 'PUT',
        body: JSON.stringify({ mappingId, bdmId, cityIds })
      });
      return result;
    } catch (err) {
      console.error('Error in updateBDMCityMapping:', err);
      throw new Error(err.message || 'Failed to update BDM-City mapping');
    }
  }, [fetchWithAuth]);

  const deleteBDMCityMapping = useCallback(async (mappingId) => {
    try {
      // Try with body first, fallback to query parameter
      const result = await apiService.delete(`deleteBDMCityMapping?mappingId=${mappingId}`, { mappingId });
      return result;
    } catch (err) {
      console.error('Error in deleteBDMCityMapping:', err);
      throw new Error(err.message || 'Failed to delete BDM-City mapping');
    }
  }, []);

  const createUser = useCallback(async (userData) => {
    try {
      console.log('🔍 useApi createUser - Sending request:', userData);
      console.log('🔍 useApi createUser - Profile image URL:', userData.profileImageUrl);
      const result = await fetchWithAuth('createUser', {
        method: 'POST',
        body: JSON.stringify(userData)
      });
      console.log('✅ useApi createUser - Response received:', result);
      return result;
    } catch (err) {
      console.error('Error in createUser:', err);
      console.error('❌ useApi createUser - Request data was:', userData);
      throw new Error(err.message || 'Failed to create user');
    }
  }, [fetchWithAuth]);


const createDealer = useCallback(async (dealerData) => {
  try {
    const result = await apiService.createDealer(dealerData);
    console.log('🔍 createDealer result:', result);
    return result;
  } catch (err) {
    console.error('Error in createDealer:', err);
    throw new Error(err.message || 'Failed to create dealer');
  }
}, [fetchWithAuth]);

const DealerContract = useCallback(async (dealerData) => {
  try {
    const result = await apiService.DealerContract(dealerData);
    console.log('🔍 DealerContract result:', result);
    return result;
  } catch (err) {
    console.error('Error in DealerContract:', err);
    throw new Error(err.message || 'Failed to create dealer');
  }
}, [fetchWithAuth]);


const uploadDocuments = useCallback(async (dealerData) => {
  try {
    const result = await apiService.uploadDocuments(dealerData);
    console.log('🔍 uploadDocuments result:', result);
    return result;
  } catch (err) {
    console.error('Error in uploadDocuments:', err);
    throw new Error(err.message || 'Failed to create dealer');
  }
}, [fetchWithAuth]);



const  createDealerInfo = useCallback(async (dealerData) => {
  try {
    const result = await apiService.createDealerInfo(dealerData);
    console.log('🔍 DealerInfo result:', result);
    return result;
  } catch (err) {
    console.error('Error in DealerInfo', err);
    throw new Error(err.message || 'Failed to create dealer');
  }
}, [fetchWithAuth]);



const RegisterDealer = useCallback(async (dealerData) => {
  try {
    const result = await apiService.RegisterDealer(dealerData);
    console.log('🔍 createDealer result:', result);
    return result;
  } catch (err) {
    console.error('Error in createDealer:', err);
    throw new Error(err.message || 'Failed to create dealer');
  }
}, [fetchWithAuth]);




  const updateUser = useCallback(async (userId, userData) => {
    try {
      const requestData = { userId, ...userData };
      console.log('🔍 useApi updateUser - Sending request:', requestData);
      console.log('🔍 useApi updateUser - Profile image URL:', userData.profileImageUrl);
      console.log('🔍 useApi updateUser - Profile image URL in requestData:', requestData.profileImageUrl);
      console.log('🔍 useApi updateUser - Profile image URL type:', typeof requestData.profileImageUrl);
      console.log('🔍 useApi updateUser - Profile image URL is undefined?', requestData.profileImageUrl === undefined);
      console.log('🔍 useApi updateUser - Profile image URL is null?', requestData.profileImageUrl === null);
      
      const result = await fetchWithAuth('updateUser', {
        method: 'PUT',
        body: JSON.stringify(requestData)
      });
      
      console.log('✅ useApi updateUser - Response received:', result);
      return result;
    } catch (err) {
      console.error('❌ useApi updateUser - Error:', err);
      console.error('❌ useApi updateUser - Request data was:', { userId, ...userData });
      
      // Extract error message from different possible error formats
      let errorMessage = 'Failed to update user';
      
      if (err.message) {
        errorMessage = err.message;
      } else if (err.error) {
        errorMessage = err.error;
      } else if (typeof err === 'string') {
        errorMessage = err;
      } else if (err.response?.data?.error) {
        errorMessage = err.response.data.error;
      } else if (err.response?.data?.message) {
        errorMessage = err.response.data.message;
      }
      
      console.error('❌ useApi updateUser - Extracted error message:', errorMessage);
      throw new Error(errorMessage);
    }
  }, [fetchWithAuth]);

  const updateDealerBankingDetails = useCallback(async (dealerId, bankingData) => {
    try {
      const requestData = { dealerId, ...bankingData };
      console.log('🔍 useApi updateDealerBankingDetails - Sending request:', requestData);
      
      const result = await fetchWithAuth('updateDealerBankingDetails', {
        method: 'POST',
        body: JSON.stringify(requestData)
      });
      
      console.log('✅ useApi updateDealerBankingDetails - Response received:', result);
      return result;
    } catch (err) {
      console.error('❌ useApi updateDealerBankingDetails - Error:', err);
      throw err;
    }
  }, [fetchWithAuth]);

  const deleteUser = useCallback(async (userId) => {
    try {
      const result = await fetchWithAuth('deleteUser', {
        method: 'DELETE',
        body: JSON.stringify({ userId })
      });
      return result;
    } catch (err) {
      console.error('Error in deleteUser:', err);
      throw new Error(err.message || 'Failed to delete user');
    }
  }, [fetchWithAuth]);

  const createOrganization = useCallback(async (orgData) => {
    try {
      const result = await fetchWithAuth('createOrganization', {
        method: 'POST',
        body: JSON.stringify(orgData)
      });
      return result;
    } catch (err) {
      console.error('Error in createOrganization:', err);
      throw new Error(err.message || 'Failed to create organization');
    }
  }, [fetchWithAuth]);

  const updateOrganization = useCallback(async (orgId, orgData) => {
    try {
      const result = await fetchWithAuth('updateOrganization', {
        method: 'PUT',
        body: JSON.stringify({ orgId, ...orgData })
      });
      return result;
    } catch (err) {
      console.error('Error in updateOrganization:', err);
      throw new Error(err.message || 'Failed to update organization');
    }
  }, [fetchWithAuth]);

  const deleteOrganization = useCallback(async (orgId) => {
    try {
      const result = await fetchWithAuth('deleteOrganization', {
        method: 'DELETE',
        body: JSON.stringify({ orgId })
      });
      return result;
    } catch (err) {
      console.error('Error in deleteOrganization:', err);
      throw new Error(err.message || 'Failed to delete organization');
    }
  }, [fetchWithAuth]);

  const updateRole = useCallback(async (roleId, updateData) => {
    try {
      const requestData = { roleId, ...updateData };
      console.log('🔍 useApi updateRole - Sending request:', requestData);
      
      const result = await apiService.updateRole(requestData);
      
      console.log('✅ useApi updateRole - Response received:', result);
      return result;
    } catch (err) {
      console.error('❌ useApi updateRole - Error:', err);
      console.error('❌ useApi updateRole - Request data was:', { roleId, ...updateData });
      throw new Error(err.message || 'Failed to update role');
    }
  }, []);

  const createRole = useCallback(async (roleData) => {
    try {
      console.log('🔍 useApi createRole - Sending request:', roleData);
      
      const result = await apiService.createRole(roleData);
      
      console.log('✅ useApi createRole - Response received:', result);
      return result;
    } catch (err) {
      console.error('❌ useApi createRole - Error:', err);
      console.error('❌ useApi createRole - Request data was:', roleData);
      throw new Error(err.message || 'Failed to create role');
    }
  }, []);

  const createOTPLoginAccess = useCallback(async (accessData) => {
    try {
      console.log('🔍 useApi createOTPLoginAccess - Sending request:', accessData);
      
      const result = await fetchWithAuth('createOTPLoginAccess', {
        method: 'POST',
        body: JSON.stringify(accessData)
      });
      
      console.log('✅ useApi createOTPLoginAccess - Response received:', result);
      return result;
    } catch (err) {
      console.error('❌ useApi createOTPLoginAccess - Error:', err);
      console.error('❌ useApi createOTPLoginAccess - Request data was:', accessData);
      throw new Error(err.message || 'Failed to create OTP login access');
    }
  }, [fetchWithAuth]);

  const getAuctions = useCallback(async (orgId) => {
    try {
      const result = await fetchWithAuth(`getAuctions?orgId=${orgId}`);
      return result;
    } catch (err) {
      console.error('Error in getAuctions:', err);
      throw err;
    }
  }, [fetchWithAuth]);

  const updateAuction = useCallback(async (auctionId, data) => {
    try {
      const result = await fetchWithAuth('updateAuction', {
        method: 'POST', 
        body: JSON.stringify({ auctionId, data })
      });
      return result;
    } catch (err) {
      console.error('Error in updateAuction:', err);
      throw err;
    }
  }, [fetchWithAuth]);

  const deleteAuction = useCallback(async (auctionId) => {
    try {
      const result = await fetchWithAuth('deleteAuction', {
        method: 'POST', 
        body: JSON.stringify({ auctionId })
      });
      return result;
    } catch (err) {
      console.error('Error in deleteAuction:', err);
      throw err;
    }
  }, [fetchWithAuth]);

  const updateCar = useCallback(async (auctionId, carId, carData) => {
    try {
      const result = await fetchWithAuth('updateCar', {
        method: 'POST', 
        body: JSON.stringify({ auctionId, carId, carData })
      });
      return result;
    } catch (err) {
      console.error('Error in updateCar:', err);
      throw err;
    }
  }, [fetchWithAuth]);

  const deleteCar = useCallback(async (auctionId, carId) => {
    try {
      const result = await fetchWithAuth('deleteCar', {
        method: 'POST', 
        body: JSON.stringify({ auctionId, carId })
      });
      return result;
    } catch (err) {
      console.error('Error in deleteCar:', err);
      throw err;
    }
  }, [fetchWithAuth]);

  const uploadAuctions = useCallback(async (json, orgId) => {
    try {
      console.log('🔍 uploadAuctions called with:', { orgId, jsonLength: json?.length, sampleData: json?.[0] });
      
      // Debug: Check for Vellfire entries being sent to backend
      const vellfireEntries = json.filter(item => 
        item.model && item.model.toUpperCase().includes('VELFIRE')
      );
      if (vellfireEntries.length > 0) {
        console.log('🔍 VELLFIRE ENTRIES BEING SENT TO BACKEND:', vellfireEntries);
        vellfireEntries.forEach((entry, index) => {
          console.log(`🔍 Vellfire Entry ${index + 1}:`, {
            make: entry.make,
            model: entry.model,
            variant: entry.variant
          });
        });
      }
      
      if (!orgId) {
        throw new Error('orgId is required but was not provided');
      }
      
      if (!Array.isArray(json) || json.length === 0) {
        throw new Error('auctions data must be a non-empty array');
      }
      
      const requestBody = { auctions: json, orgId };
      console.log('🔍 Request body:', requestBody);
      
      const result = await fetchWithAuth('uploadAuctions', {
        method: 'POST', 
        body: requestBody
      });
      return result;
    } catch (err) {
      console.error('Error in uploadAuctions:', err);
      throw err;
    }
  }, [fetchWithAuth]);

  const getMakeModels = useCallback(async (orgId) => {
    try {
      const result = await fetchWithAuth(`getMakeModels?orgId=${orgId}`);
      return result;
    } catch (err) {
      console.error('Error in getMakeModels:', err);
      throw err;
    }
  }, [fetchWithAuth]);

  const getShortCodeMappings = useCallback(async (orgId) => {
    try {
      const result = await fetchWithAuth(`getShortCodeMappings?orgId=${orgId}`);
      return result;
    } catch (err) {
      console.error('Error in getShortCodeMappings:', err);
      throw err;
    }
  }, [fetchWithAuth]);

  // getNotificationProvider removed - use MSG91 functions instead

  // setNotificationProvider removed - use MSG91 functions instead

  // getNotificationTemplates removed - use MSG91 functions instead

  // upsertNotificationTemplate removed - use MSG91 functions instead

  // deleteNotificationTemplate removed - use MSG91 functions instead

  // sendNotification removed - use MSG91 functions instead

  const getMSG91EmailTemplates = async () => {
    try {
      let json;
      // const res = await fetchWithAuth('getMSG91EmailTemplates');
      json = await fetchWithAuth('getMSG91EmailTemplates');
      // // try {
      // //   json = await res.json();
      // // } catch (e) {
      // //   return { error: true, message: 'Invalid JSON response' };
      // // }
      // if (!res.ok || json.error) {
      //   return { error: true, message: json.message || `HTTP error! status: ${res.status}` };
      // }
      // Extraction logic for all possible structures
      if (Array.isArray(json)) return json;
      if (json.data && Array.isArray(json.data.data)) return json.data.data;
      if (Array.isArray(json.data)) return json.data;
      if (Array.isArray(json.templates)) return json.templates;
      if (Array.isArray(json.email_templates)) return json.email_templates;
      return [];
    } catch (err) {
      return { error: true, message: err.message || 'Failed to fetch MSG91 email templates' };
    }
  };

  const getMSG91WhatsAppTemplates = async () => {
    try {
      const res = await fetchWithAuth('getMSG91WhatsAppTemplates');
      if (!res.ok) throw new Error(`HTTP error! status: ${res.status}`);
      return await res.json();
    } catch (err) {
      return { error: true, message: err.message || 'Failed to fetch MSG91 WhatsApp templates' };
    }
  };

  const getMSG91WhatsAppFlows = async () => {
    try {
      const res = await fetchWithAuth('getMSG91WhatsAppFlows');
      if (!res.ok) throw new Error(`HTTP error! status: ${res.status}`);
      return await res.json();
    } catch (err) {
      return { error: true, message: err.message || 'Failed to fetch MSG91 WhatsApp flows' };
    }
  };

  const getMSG91AccountInfo = async () => {
    try {
      const res = await fetchWithAuth('getMSG91AccountInfo');
      if (!res.ok) throw new Error(`HTTP error! status: ${res.status}`);
      return await res.json();
    } catch (err) {
      return { error: true, message: err.message || 'Failed to fetch MSG91 account info' };
    }
  };

  const getMSG91Balance = async () => {
    try {
      const res = await fetchWithAuth('getMSG91Balance');
      if (!res.ok) throw new Error(`HTTP error! status: ${res.status}`);
      return await res.json();
    } catch (err) {
      return { error: true, message: err.message || 'Failed to fetch MSG91 balance' };
    }
  };

  const testMSG91Connectivity = async () => {
    try {
      const res = await fetchWithAuth('testMSG91Connectivity');
      if (!res.ok) throw new Error(`HTTP error! status: ${res.status}`);
      return await res.json();
    } catch (err) {
      return { error: true, message: err.message || 'Failed to test MSG91 connectivity' };
    }
  };

  const validateMSG91ApiKey = async () => {
    try {
      const res = await fetchWithAuth('validateMSG91ApiKey');
      if (!res.ok) throw new Error(`HTTP error! status: ${res.status}`);
      return await res.json();
    } catch (err) {
      return { error: true, message: err.message || 'Failed to validate MSG91 API key' };
    }
  };

  const getMSG91TemplateCategories = async () => {
    try {
      const res = await fetchWithAuth('getMSG91TemplateCategories');
      if (!res.ok) throw new Error(`HTTP error! status: ${res.status}`);
      return await res.json();
    } catch (err) {
      return { error: true, message: err.message || 'Failed to fetch MSG91 template categories' };
    }
  };

  const getMSG91AccountDetails = async () => {
    try {
      const response = await fetchWithAuth('getMSG91AccountDetails');
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      return await response.json();
    } catch (error) {
      throw new Error(`Failed to get MSG91 account details: ${error.message}`);
    }
  };

  const getMSG91TemplatesByID = async (templateId) => {
    try {
      const url = templateId 
        ? `getMSG91TemplatesByID?templateId=${encodeURIComponent(templateId)}`
        : 'getMSG91TemplatesByID';
      const response = await fetchWithAuth(url);
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      return await response.json();
    } catch (error) {
      throw new Error(`Failed to get MSG91 templates by ID: ${error.message}`);
    }
  };

  const getAllMSG91Services = async () => {
    try {
      const response = await fetchWithAuth('getAllMSG91Services');
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      return await response.json();
    } catch (error) {
      throw new Error(`Failed to get all MSG91 services: ${error.message}`);
    }
  };

  const getMSG91EmailTemplateDetails = async (slug) => {
    try {
      const res = await fetchWithAuth(`getMSG91EmailTemplateDetails?slug=${encodeURIComponent(slug)}`);
      if (!res.ok) throw new Error(`HTTP error! status: ${res.status}`);
      return await res.json();
    } catch (err) {
      return { error: true, message: err.message || 'Failed to fetch MSG91 email template details' };
    }
  };

  // Dealer-City Mapping API
  const getDealerCityMappings = async () => {
    try {
      const res = await fetchWithAuth('getDealerCityMappings');
      if (!res) throw new Error('Failed to fetch dealer-city mappings');
      return res;
    } catch (err) {
      throw err;
    }
  };

  const createDealerCityMapping = async (dealerId, cityIds) => {
    try {
      const res = await fetchWithAuth('createDealerCityMapping', {
        method: 'POST',
        body: JSON.stringify({ dealerId, cityIds })
      });
      if (!res) throw new Error('Failed to create dealer-city mapping');
      return res;
    } catch (err) {
      throw err;
    }
  };

  const updateDealerCityMapping = async (mappingId, dealerId, cityIds) => {
    try {
      const res = await fetchWithAuth('updateDealerCityMapping', {
        method: 'POST',
        body: JSON.stringify({ mappingId, dealerId, cityIds })
      });
      if (!res) throw new Error('Failed to update dealer-city mapping');
      return res;
    } catch (err) {
      throw err;
    }
  };

  const deleteDealerCityMapping = async (mappingId) => {
    try {
      const res = await fetchWithAuth('deleteDealerCityMapping', {
        method: 'POST',
        body: JSON.stringify({ mappingId })
      });
      if (!res) throw new Error('Failed to delete dealer-city mapping');
      return res;
    } catch (err) {
      throw err;
    }
  };

  const getAllDriversForOrg = useCallback(async (orgId) => {
    try {
      const result = await fetchWithAuth(`getAllDriversForOrg?orgId=${orgId}`);
      return result;
    } catch (err) {
      console.error('Error in getAllDriversForOrg:', err);
      throw err;
    }
  }, [fetchWithAuth]);

  const getCars = useCallback(async (orgId, page = 1, limit = 50) => {
    try {
      const params = new URLSearchParams({
        organization: orgId,
        page: page.toString(),
        limit: limit.toString()
      });
      const result = await fetchWithAuth(`getCars?${params.toString()}`);
      return result;
    } catch (err) {
      console.error('Error in getCars:', err);
      throw err;
    }
  }, [fetchWithAuth]);

  const getGatepasses = useCallback(async () => {
    try {
      const result = await fetchWithAuth('getGatepasses');
      if (!result) {
        throw new Error('No data received from server');
      }
      return result;
    } catch (err) {
      console.error('Error in getGatepasses:', err);
      throw new Error(err.message || 'Failed to fetch gatepasses');
    }
  }, [fetchWithAuth]);

  const getGatepassesForBDM = useCallback(async () => {
    try {
      console.log('🔍 DEBUG: getGatepassesForBDM called');
      const result = await fetchWithAuth('getGatepassesForBDM');
      console.log('🔍 DEBUG: getGatepassesForBDM result:', result);
      if (!result) {
        throw new Error('No data received from server');
      }
      return result;
    } catch (err) {
      console.error('Error in getGatepassesForBDM:', err);
      throw new Error(err.message || 'Failed to fetch gatepasses for BDM');
    }
  }, [fetchWithAuth]);

  const getBDMData = useCallback(async (options = {}) => {
    try {
      console.log('🔍 DEBUG: getBDMDataOptimized called with options:', options);
      
      // Default options for optimized performance
      const defaultOptions = {
        useCache: 'true',           // Enable caching for 90% faster repeated requests
        includeDetails: 'false'     // Lightweight response for mobile performance
      };
      
      const queryParams = { ...defaultOptions, ...options };
      const queryString = new URLSearchParams(queryParams).toString();
      
      const result = await fetchWithAuth(`getBDMDataOptimized?${queryString}`);
      console.log('🔍 DEBUG: getBDMDataOptimized result:', result);
      
      if (!result) {
        throw new Error('No data received from server');
      }
      
      // Log performance metrics if available
      if (result.performance) {
        console.log('⚡ BDM Data Performance:', {
          responseTime: `${result.performance.totalTime || result.responseTime}ms`,
          cached: result.cached || false,
          itemsProcessed: result.performance.itemsProcessed || 'N/A'
        });
      }
      
      return result;
    } catch (err) {
      console.error('Error in getBDMDataOptimized:', err);
      throw new Error(err.message || 'Failed to fetch BDM data');
    }
  }, [fetchWithAuth]);

  // Optimized BDM Dashboard Metrics
  const getBDMDashboardMetricsOptimized = useCallback(async () => {
    try {
      console.log('🔍 DEBUG: getBDMDashboardMetricsOptimized called');
      const result = await fetchWithAuth('getBDMDashboardMetricsOptimized');
      
      if (result && result.performance) {
        console.log('⚡ BDM Dashboard Performance:', {
          responseTime: `${result.responseTime}ms`,
          cached: result.cached || false
        });
      }
      
      return result;
    } catch (err) {
      console.error('Error in getBDMDashboardMetricsOptimized:', err);
      throw new Error(err.message || 'Failed to fetch BDM dashboard metrics');
    }
  }, [fetchWithAuth]);

  // Optimized BDM Cars by Status with Pagination
  const getBDMCarsByStatusOptimized = useCallback(async (status = 'all', page = 1, limit = 50) => {
    try {
      const queryParams = new URLSearchParams({ 
        status, 
        page: page.toString(), 
        limit: limit.toString() 
      }).toString();
      
      console.log('🔍 DEBUG: getBDMCarsByStatusOptimized called with:', { status, page, limit });
      const result = await fetchWithAuth(`getBDMCarsByStatusOptimized?${queryParams}`);
      
      if (result && result.responseTime) {
        console.log('⚡ BDM Cars Performance:', {
          responseTime: `${result.responseTime}ms`,
          total: result.pagination?.total || 0,
          page: result.pagination?.page || 1
        });
      }
      
      return result;
    } catch (err) {
      console.error('Error in getBDMCarsByStatusOptimized:', err);
      throw new Error(err.message || 'Failed to fetch BDM cars by status');
    }
  }, [fetchWithAuth]);

  const updateGatepassStatus = useCallback(async (gatepassIdOrData, status) => {
    // Handle both calling patterns:
    // 1. updateGatepassStatus(gatepassId, status) - two parameters
    // 2. updateGatepassStatus({ gatepassId, status }) - object parameter
    let actualGatepassId, actualStatus;
    
    if (typeof gatepassIdOrData === 'object' && gatepassIdOrData !== null) {
      // Called with object: { gatepassId, status }
      actualGatepassId = gatepassIdOrData.gatepassId;
      actualStatus = gatepassIdOrData.status;
    } else {
      // Called with two parameters: (gatepassId, status)
      actualGatepassId = gatepassIdOrData;
      actualStatus = status;
    }
    
    console.log('🔍 DEBUG: updateGatepassStatus called with:', { actualGatepassId, actualStatus });
    try {
      const result = await fetchWithAuth('updateGatepassStatus', {
        method: 'POST',
        body: JSON.stringify({ gatepassId: actualGatepassId, status: actualStatus })
      });
      console.log('✅ DEBUG: updateGatepassStatus success result:', result);
      return result;
    } catch (error) {
      console.error('❌ DEBUG: updateGatepassStatus error:', error);
      throw error;
    }
  }, [fetchWithAuth]);

  const updateCarWorkflowState = useCallback(async (carId, newState, additionalData = {}) => {
    try {
      const result = await fetchWithAuth('updateCarWorkflowState', {
        method: 'POST',
        body: JSON.stringify({ carId, newState, additionalData })
      });
      
      return result;
    } catch (error) {
      console.error('Error updating car workflow state:', error);
      throw error;
    }
  }, [fetchWithAuth]);

  const getBDMDashboardMetrics = useCallback(async () => {
    try {
      const result = await fetchWithAuth('getBDMDashboardMetrics');
      if (!result) {
        throw new Error('No data received from server');
      }
      return result;
    } catch (err) {
      console.error('Error in getBDMDashboardMetrics:', err);
      throw new Error(err.message || 'Failed to fetch BDM dashboard metrics');
    }
  }, [fetchWithAuth]);

  const getCarsSoldCount = useCallback(async () => {
    try {
      const result = await fetchWithAuth('getCarsSoldCount');
      if (!result) {
        throw new Error('No data received from server');
      }
      return result;
    } catch (err) {
      console.error('Error in getCarsSoldCount:', err);
      throw new Error(err.message || 'Failed to fetch cars sold count');
    }
  }, [fetchWithAuth]);

  const getActiveBidsCount = useCallback(async () => {
    try {
      const result = await fetchWithAuth('getActiveBidsCount');
      if (!result) {
        throw new Error('No data received from server');
      }
      return result;
    } catch (err) {
      console.error('Error in getActiveBidsCount:', err);
      throw new Error(err.message || 'Failed to fetch active bids count');
    }
  }, [fetchWithAuth]);

  const getCompletedPaymentsCount = useCallback(async () => {
    try {
      const result = await fetchWithAuth('getCompletedPaymentsCount');
      if (!result) {
        throw new Error('No data received from server');
      }
      return result;
    } catch (err) {
      console.error('Error in getCompletedPaymentsCount:', err);
      throw new Error(err.message || 'Failed to fetch completed payments count');
    }
  }, [fetchWithAuth]);

  const getKYCVerifiedCount = useCallback(async () => {
    try {
      const result = await fetchWithAuth('getKYCVerifiedCount');
      if (!result) {
        throw new Error('No data received from server');
      }
      return result;
    } catch (err) {
      console.error('Error in getKYCVerifiedCount:', err);
      throw new Error(err.message || 'Failed to fetch KYC verified count');
    }
  }, [fetchWithAuth]);

  const getNOCApprovedCount = useCallback(async () => {
    try {
      const result = await fetchWithAuth('getNOCApprovedCount');
      if (!result) {
        throw new Error('No data received from server');
      }
      return result;
    } catch (err) {
      console.error('Error in getNOCApprovedCount:', err);
      throw new Error(err.message || 'Failed to fetch NOC approved count');
    }
  }, [fetchWithAuth]);

  const getCarsOwnCount = useCallback(async () => {
    try {
      const result = await fetchWithAuth('getCarsOwnCount');
      if (!result) {
        throw new Error('No data received from server');
      }
      return result;
    } catch (err) {
      console.error('Error in getCarsOwnCount:', err);
      throw new Error(err.message || 'Failed to fetch cars own count');
    }
  }, [fetchWithAuth]);

  // Driver management functions
  const getDrivers = useCallback(async (type = null) => {
    try {
      const url = type ? `getDrivers?type=${encodeURIComponent(type)}` : 'getDrivers';
      const result = await fetchWithAuth(url);
      return result;
    } catch (err) {
      console.error('Error in getDrivers:', err);
      throw err;
    }
  }, [fetchWithAuth]);

  const createDriver = useCallback(async (driverData) => {
    try {
      const result = await fetchWithAuth('createDriver', {
        method: 'POST',
        body: JSON.stringify(driverData)
      });
      return result;
    } catch (err) {
      console.error('Error in createDriver:', err);
      throw err;
    }
  }, [fetchWithAuth]);

  const updateDriver = useCallback(async (driverId, driverData) => {
    try {
      const result = await fetchWithAuth('updateDriver', {
        method: 'POST',
        body: JSON.stringify({ driverId, driverData })
      });
      return result;
    } catch (err) {
      console.error('Error in updateDriver:', err);
      throw err;
    }
  }, [fetchWithAuth]);

  const deleteDriver = useCallback(async (driverId) => {
    try {
      const result = await fetchWithAuth('deleteDriver', {
        method: 'POST',
        body: JSON.stringify({ driverId })
      });
      return result;
    } catch (err) {
      console.error('Error in deleteDriver:', err);
      throw err;
    }
  }, [fetchWithAuth]);

  // Supplier management functions
  const getSuppliers = useCallback(async () => {
    try {
      const result = await fetchWithAuth('getSuppliers');
      return result;
    } catch (err) {
      console.error('Error in getSuppliers:', err);
      throw err;
    }
  }, [fetchWithAuth]);

  const createSupplier = useCallback(async (supplierData) => {
    try {
      const result = await fetchWithAuth('createSupplier', {
        method: 'POST',
        body: JSON.stringify(supplierData)
      });
      return result;
    } catch (err) {
      console.error('Error in createSupplier:', err);
      throw err;
    }
  }, [fetchWithAuth]);

  const updateSupplier = useCallback(async (supplierData) => {
    try {
      const result = await fetchWithAuth('updateSupplier', {
        method: 'POST',
        body: JSON.stringify(supplierData)
      });
      return result;
    } catch (err) {
      console.error('Error in updateSupplier:', err);
      throw err;
    }
  }, [fetchWithAuth]);

  const deleteSupplier = useCallback(async (supplierId) => {
    try {
      const result = await fetchWithAuth('deleteSupplier', {
        method: 'POST',
        body: JSON.stringify({ supplierId })
      });
      return result;
    } catch (err) {
      console.error('Error in deleteSupplier:', err);
      throw err;
    }
  }, [fetchWithAuth]);

  const uploadSupplierLogo = useCallback(async (imageData, fileName) => {
    try {
      const result = await fetchWithAuth('uploadSupplierLogo', {
        method: 'POST',
        body: JSON.stringify({ imageData, fileName })
      });
      return result;
    } catch (err) {
      console.error('Error in uploadSupplierLogo:', err);
      throw err;
    }
  }, [fetchWithAuth]);

  const submitSupplier = useCallback(async (supplierData) => {
    try {
      const result = await fetchWithAuth('submitSupplier', {
        method: 'POST',
        body: JSON.stringify(supplierData)
      });
      return result;
    } catch (err) {
      console.error('Error in submitSupplier:', err);
      throw err;
    }
  }, [fetchWithAuth]);

  const importSuppliers = useCallback(async (suppliers, orgid) => {
    try {
      const result = await fetchWithAuth('importSuppliers', {
        method: 'POST',
        body: JSON.stringify({ suppliers, orgid })
      });
      return result;
    } catch (err) {
      console.error('Error in importSuppliers:', err);
      throw err;
    }
  }, [fetchWithAuth]);

  // Sales Persons management functions
  const getSalesPersons = useCallback(async (supplierId) => {
    try {
      const result = await fetchWithAuth(`getSalesPersons?supplierId=${encodeURIComponent(supplierId)}`);
      return result;
    } catch (err) {
      console.error('Error in getSalesPersons:', err);
      throw err;
    }
  }, [fetchWithAuth]);

  const uploadSalesPersons = useCallback(async (salesPersons, supplierId) => {
    try {
      console.log('🔍 uploadSalesPersons - Calling endpoint with:', { salesPersonsCount: salesPersons.length, supplierId });
      const result = await fetchWithAuth('uploadSalesPersons', {
        method: 'POST',
        body: JSON.stringify({ salesPersons, supplierId })
      });
      console.log('🔍 uploadSalesPersons - Result:', result);
      return result;
    } catch (err) {
      console.error('❌ Error in uploadSalesPersons:', err);
      console.error('❌ Error details:', {
        message: err.message,
        stack: err.stack,
        name: err.name
      });
      throw err;
    }
  }, [fetchWithAuth]);

  const deleteSalesPerson = useCallback(async (whatsappNumber, supplierId) => {
    try {
      const result = await fetchWithAuth('deleteSalesPerson', {
        method: 'POST',
        body: JSON.stringify({ whatsappNumber, supplierId })
      });
      return result;
    } catch (err) {
      console.error('Error in deleteSalesPerson:', err);
      throw err;
    }
  }, [fetchWithAuth]);

  // Gatepass management functions
  const createGatepass = useCallback(async (gatepassData) => {
    try {
      const result = await fetchWithAuth('createGatepass', {
        method: 'POST',
        body: JSON.stringify(gatepassData)
      });
      return result;
    } catch (err) {
      console.error('Error in createGatepass:', err);
      throw err;
    }
  }, [fetchWithAuth]);

  // Favorites management functions
  const getFavorites = useCallback(async (auctionId) => {
    try {
      const result = await fetchWithAuth(`getFavorites?auctionId=${auctionId}`);
      return result;
    } catch (err) {
      console.error('Error in getFavorites:', err);
      throw err;
    }
  }, [fetchWithAuth]);

  const addFavorite = useCallback(async (auctionId, carId) => {
    try {
      const result = await fetchWithAuth('addFavorite', {
        method: 'POST',
        body: JSON.stringify({ auctionId, carId })
      });
      return result;
    } catch (err) {
      console.error('Error in addFavorite:', err);
      throw err;
    }
  }, [fetchWithAuth]);

  const removeFavorite = useCallback(async (auctionId, carId) => {
    try {
      const result = await fetchWithAuth('removeFavorite', {
        method: 'POST',
        body: JSON.stringify({ auctionId, carId })
      });
      return result;
    } catch (err) {
      console.error('Error in removeFavorite:', err);
      throw err;
    }
  }, [fetchWithAuth]);

  const getAllFavoritesForUser = useCallback(async () => {
    try {
      const result = await fetchWithAuth('getAllFavoritesForUser');
      return result;
    } catch (err) {
      console.error('Error in getAllFavoritesForUser:', err);
      throw err;
    }
  }, [fetchWithAuth]);

  // Document management functions
  const getAllDocuments = useCallback(async () => {
    try {
      const currentUser = authCtx?.currentUser;
      if (!currentUser?.uid) {
        throw new Error('User not authenticated');
      }
      
      const requestBody = {
        collectionName: 'flow_entity',
        filters: [
          {
            field: 'dealer_id',
            operator: '==',
            value: currentUser.uid
          }
        ],
        orderBy: undefined,
        limit: undefined
      };
      
      const result = await fetchWithAuth('getAllDocuments', {
        method: 'POST',
        body: JSON.stringify(requestBody)
      });
      return result;
    } catch (err) {
      console.error('Error in getAllDocuments:', err);
      throw err;
    }
  }, [fetchWithAuth, authCtx?.currentUser?.uid]);

  // Get dealer's flow entities (My Cars) - simpler API
  // Get dealer's flow entities (My Cars) - simpler API
  const getDealerFlowEntities = useCallback(async (dealerId) => {
    try {
      const result = await fetchWithAuth(`getDealerFlowEntities?dealerId=${dealerId}`);
      return result;
    } catch (err) {
      console.error('Error in getDealerFlowEntities:', err);
      throw err;
    }
  }, [fetchWithAuth]);

  const getDocumentById = useCallback(async (collectionName, id) => {
    try {
      const result = await fetchWithAuth(`getDocumentById?collectionName=${collectionName}&id=${id}`);
      return result;
    } catch (err) {
      console.error('Error in getDocumentById:', err);
      throw err;
    }
  }, [fetchWithAuth]);

  const updateDocument = useCallback(async (collectionName, id, data) => {
    try {
      const result = await fetchWithAuth('updateDocument', {
        method: 'POST',
        body: JSON.stringify({ collectionName, id, data })
      });
      return result;
    } catch (err) {
      console.error('Error in updateDocument:', err);
      throw err;
    }
  }, [fetchWithAuth]);

  // Bid management functions
  const getBidCount = useCallback(async () => {
    try {
      const result = await fetchWithAuth('getBidCount');
      return result;
    } catch (err) {
      console.error('Error in getBidCount:', err);
      throw err;
    }
  }, [fetchWithAuth]);

  const getAvailableCarsForBidding = useCallback(async () => {
    try {
      const result = await fetchWithAuth('getAvailableCarsForBidding');
      return result;
    } catch (err) {
      console.error('Error in getAvailableCarsForBidding:', err);
      throw err;
    }
  }, [fetchWithAuth]);

  const getBids = useCallback(async () => {
    try {
      const result = await fetchWithAuth('getBids');
      return result;
    } catch (err) {
      console.error('Error in getBids:', err);
      throw err;
    }
  }, [fetchWithAuth]);

  const submitBidWithLimit = useCallback(async (bidData) => {
    try {
      const result = await fetchWithAuth('submitBidWithLimit', {
        method: 'POST',
        body: JSON.stringify(bidData)
      });
      return result;
    } catch (err) {
      console.error('Error in submitBidWithLimit:', err);
      throw err;
    }
  }, [fetchWithAuth]);

  const saveBidData = useCallback(async (bidData) => {
    try {
      const result = await fetchWithAuth('saveBidData', {
        method: 'POST',
        body: JSON.stringify(bidData)
      });
      return result;
    } catch (err) {
      console.error('Error in saveBidData:', err);
      throw err;
    }
  }, [fetchWithAuth]);

  const getBidData = useCallback(async () => {
    try {
      const result = await fetchWithAuth('getBidData');
      return result;
    } catch (err) {
      console.error('Error in getBidData:', err);
      throw err;
    }
  }, [fetchWithAuth]);

  // Payment and notification functions
  const getPaymentNotifications = useCallback(async () => {
    try {
      const result = await fetchWithAuth('getPaymentNotifications');
      return result;
    } catch (err) {
      console.error('Error in getPaymentNotifications:', err);
      throw err;
    }
  }, [fetchWithAuth]);

  const savePaymentNotifications = useCallback(async (notifications) => {
    try {
      const result = await fetchWithAuth('savePaymentNotifications', {
        method: 'POST',
        body: JSON.stringify({ notifications })
      });
      return result;
    } catch (err) {
      console.error('Error in savePaymentNotifications:', err);
      throw err;
    }
  }, [fetchWithAuth]);

  // Yard and car management functions
  const getMyCarsByYard = useCallback(async () => {
    try {
      const result = await fetchWithAuth('getMyCarsByYard');
      return result;
    } catch (err) {
      console.error('Error in getMyCarsByYard:', err);
      throw err;
    }
  }, [fetchWithAuth]);

  const requestGatepassForYard = useCallback(async (requestData) => {
    try {
      const result = await fetchWithAuth('requestGatepassForYard', {
        method: 'POST',
        body: JSON.stringify(requestData)
      });
      return result;
    } catch (err) {
      console.error('Error in requestGatepassForYard:', err);
      throw err;
    }
  }, [fetchWithAuth]);

  const addToMyCars = useCallback(async (carData) => {
    try {
      const result = await fetchWithAuth('addToMyCars', {
        method: 'POST',
        body: JSON.stringify(carData)
      });
      return result;
    } catch (err) {
      console.error('Error in addToMyCars:', err);
      throw err;
    }
  }, [fetchWithAuth]);

  const submitYard = useCallback(async (yardData) => {
    try {
      const result = await apiService.submitYard(yardData);
      return result;
    } catch (err) {
      console.error('Error in submitYard:', err);
      throw err;
    }
  }, []);

  const updateYard = useCallback(async (yardData) => {
    try {
      const result = await apiService.updateYard(yardData);
      return result;
    } catch (err) {
      console.error('Error in updateYard:', err);
      throw err;
    }
  }, []);

  const deleteYard = useCallback(async (yardId) => {
    try {
      const result = await apiService.deleteYard(yardId);
      return result;
    } catch (err) {
      console.error('Error in deleteYard:', err);
      throw err;
    }
  }, []);

  const getYards = useCallback(async () => {
    try {
      const result = await apiService.getYards();
      return result;
    } catch (err) {
      console.error('Error in getYards:', err);
      throw err;
    }
  }, []);

  const importYards = useCallback(async (yards, orgid) => {
    try {
      const result = await apiService.importYards({ yards, orgid });
      return result;
    } catch (err) {
      console.error('Error in importYards:', err);
      throw err;
    }
  }, []);

  // Debug and utility functions
  const clearTestBids = useCallback(async () => {
    try {
      const result = await fetchWithAuth('clearTestBids');
      return result;
    } catch (err) {
      console.error('Error in clearTestBids:', err);
      throw err;
    }
  }, [fetchWithAuth]);

  const debugGatepasses = useCallback(async () => {
    try {
      const result = await fetchWithAuth('debugGatepasses');
      return result;
    } catch (err) {
      console.error('Error in debugGatepasses:', err);
      throw err;
    }
  }, [fetchWithAuth]);

  // Car management functions for AuctionsPage
  const updateCarFlat = useCallback(async (carId, carData) => {
    try {
      const result = await fetchWithAuth('updateCarFlat', {
        method: 'POST',
        body: JSON.stringify({ carId, carData })
      });
      return result;
    } catch (err) {
      console.error('Error in updateCarFlat:', err);
      throw err;
    }
  }, [fetchWithAuth]);

  const deleteCarFlat = useCallback(async (carId) => {
    try {
      const result = await fetchWithAuth('deleteCarFlat', {
        method: 'POST',
        body: JSON.stringify({ carId })
      });
      return result;
    } catch (err) {
      console.error('Error in deleteCarFlat:', err);
      throw err;
    }
  }, [fetchWithAuth]);

  const updateCarsBulk = useCallback(async (carIds, published) => {
    try {
      const result = await fetchWithAuth('updateCarsBulk', {
        method: 'POST',
        body: JSON.stringify({ carIds, published })
      });
      return result;
    } catch (err) {
      console.error('Error in updateCarsBulk:', err);
      throw err;
    }
  }, [fetchWithAuth]);

  const bulkUpdateCarsWithFlowEntities = useCallback(async (carIds, taEndDate, isActive) => {
    try {
      const result = await fetchWithAuth('bulkUpdateCarsWithFlowEntities', {
        method: 'POST',
        body: JSON.stringify({ carIds, taEndDate, isActive })
      });
      return result;
    } catch (err) {
      console.error('Error in bulkUpdateCarsWithFlowEntities:', err);
      throw err;
    }
  }, [fetchWithAuth]);

  const updateCarsViaExcel = useCallback(async (cars, orgId) => {
    try {
      const result = await fetchWithAuth('updateCarsViaExcel', {
        method: 'POST',
        body: JSON.stringify({ cars, orgId })
      });
      return result;
    } catch (err) {
      console.error('Error in updateCarsViaExcel:', err);
      throw err;
    }
  }, [fetchWithAuth]);

  const exportAuctions = useCallback(async (orgId) => {
    try {
      const result = await fetchWithAuth(`exportAuctions?orgId=${orgId}`);
      return result;
    } catch (err) {
      console.error('Error in exportAuctions:', err);
      throw err;
    }
  }, [fetchWithAuth]);

  const getDealerEvaluationCars = useCallback(async () => {
    try {
      const result = await fetchWithAuth('getDealerEvaluationCars');
      return result;
    } catch (err) {
      console.error('Error in getDealerEvaluationCars:', err);
      throw err;
    }
  }, [fetchWithAuth]);

  const getDealerPlaceBidsCars = useCallback(async () => {
    try {
      const result = await fetchWithAuth('getDealerPlaceBidsCars');
      return result;
    } catch (err) {
      console.error('Error in getDealerPlaceBidsCars:', err);
      throw err;
    }
  }, [fetchWithAuth]);

  const getDealerPaymentCars = useCallback(async () => {
    try {
      const result = await fetchWithAuth('getDealerPaymentCars');
      return result;
    } catch (err) {
      console.error('Error in getDealerPaymentCars:', err);
      throw err;
    }
  }, [fetchWithAuth]);

  const getBDMPaymentCars = useCallback(async () => {
    try {
      const result = await fetchWithAuth('getBDMPaymentCars');
      return result;
    } catch (err) {
      console.error('Error in getBDMPaymentCars:', err);
      throw err;
    }
  }, [fetchWithAuth]);

  const getFinanceApprovalData = useCallback(async () => {
    try {
      const result = await fetchWithAuth('getFinanceApprovalData');
      return result;
    } catch (err) {
      console.error('Error in getFinanceApprovalData:', err);
      throw err;
    }
  }, [fetchWithAuth]);

  const getHeadFinanceApprovalData = useCallback(async () => {
    try {
      const result = await fetchWithAuth('getHeadFinanceApprovalData');
      return result;
    } catch (err) {
      console.error('Error in getHeadFinanceApprovalData:', err);
      throw err;
    }
  }, [fetchWithAuth]);

  const getBDMEvaluationCars = useCallback(async () => {
    try {
      const result = await fetchWithAuth('getBDMEvaluationCars');
      return result;
    } catch (err) {
      console.error('Error in getBDMEvaluationCars:', err);
      throw err;
    }
  }, [fetchWithAuth]);

  const getBDMPlaceBidsCars = useCallback(async () => {
    try {
      const result = await fetchWithAuth('getBDMPlaceBidsCars');
      return result;
    } catch (err) {
      console.error('Error in getBDMPlaceBidsCars:', err);
      throw err;
    }
  }, [fetchWithAuth]);

  const getAuctionhelperData = useCallback(async () => {
    try {
      const result = await fetchWithAuth('getAuctionhelperData');
      return result;
    } catch (err) {
      console.error('Error in getAuctionhelperData:', err);
      throw err;
    }
  }, [fetchWithAuth]);

  const awardBidWinner = useCallback(async ({ carId, flowEntityId, auctionWinAmount, auctionDepositAmount, awardedToDealerAmount, kycTimeDays }) => {
    try {
      const result = await fetchWithAuth('awardBidWinner', {
        method: 'POST',
        body: JSON.stringify({
          carId,
          flowEntityId,
          auctionWinAmount,
          auctionDepositAmount,
          awardedToDealerAmount,
          kycTimeDays
        })
      });
      return result;
    } catch (err) {
      console.error('Error in awardBidWinner:', err);
      throw err;
    }
  }, [fetchWithAuth]);

  const declineBid = useCallback(async ({ carId, flowEntityId }) => {
    try {
      const result = await fetchWithAuth('declineBid', {
        method: 'POST',
        body: JSON.stringify({
          carId,
          flowEntityId
        })
      });
      return result;
    } catch (err) {
      console.error('Error in declineBid:', err);
      throw err;
    }
  }, [fetchWithAuth]);

  const getDealerHomeData = useCallback(async (orgId, city = null) => {
    try {
      const result = await apiService.getDealerHomeData(orgId, 'adminuid');
      return result;
    } catch (err) {
      console.error('Error in getDealerHomeData:', err);
      throw err;
    }
  }, []);

  const getDealerCarsByCity = useCallback(async (orgId, city) => {
    try {
      const result = await apiService.getDealerCarsByCity(orgId, 'adminuid', city);
      return result;
    } catch (err) {
      console.error('Error in getDealerCarsByCity:', err);
      throw err;
    }
  }, []);

  const shareEvalLink = useCallback(async (requestData) => {
    try {
      const result = await fetchWithAuth('shareEvalLink', {
        method: 'POST',
        body: JSON.stringify(requestData)
      });
      return result;
    } catch (err) {
      console.error('Error in shareEvalLink:', err);
      throw err;
    }
  }, [fetchWithAuth]);

  const generateObfuscatedEvaluationLink = useCallback(async (requestData) => {
    try {
      const result = await fetchWithAuth('generateObfuscatedEvaluationLink', {
        method: 'POST',
        body: JSON.stringify(requestData)
      });
      return result;
    } catch (err) {
      console.error('Error in generateObfuscatedEvaluationLink:', err);
      throw err;
    }
  }, [fetchWithAuth]);

  const getEvaluationLinkData = useCallback(async (token) => {
    try {
      const result = await fetchWithAuth(`getEvaluationLinkData?token=${token}`, {
        method: 'GET'
      });
      return result;
    } catch (err) {
      console.error('Error in getEvaluationLinkData:', err);
      throw err;
    }
  }, [fetchWithAuth]);

  const getDriverByPhone = useCallback(async (phone, orgId) => {
    try {
      const result = await fetchWithAuth(`getDriverByPhone?phone=${encodeURIComponent(phone)}&orgId=${encodeURIComponent(orgId)}`, {
        method: 'GET'
      });
      return result;
    } catch (err) {
      console.error('Error in getDriverByPhone:', err);
      throw err;
    }
  }, [fetchWithAuth]);

  const createDriverUserAccount = useCallback(async (userData) => {
    try {
      const result = await fetchWithAuth('createDriverUserAccount', {
        method: 'POST',
        body: JSON.stringify(userData)
      });
      return result;
    } catch (err) {
      console.error('Error in createDriverUserAccount:', err);
      throw err;
    }
  }, [fetchWithAuth]);

  const getDriverCarsByYard = useCallback(async (driverId, orgId, dealerId) => {
    try {
      const result = await fetchWithAuth(`getDriverCarsByYard?driverId=${encodeURIComponent(driverId)}&orgId=${encodeURIComponent(orgId)}&dealerId=${encodeURIComponent(dealerId)}`, {
        method: 'GET'
      });
      return result;
    } catch (err) {
      console.error('Error in getDriverCarsByYard:', err);
      throw err;
    }
  }, [fetchWithAuth]);

  const debugDriverData = useCallback(async (driverId) => {
    try {
      const result = await fetchWithAuth(`debugDriverData?driverId=${encodeURIComponent(driverId)}`, {
        method: 'GET'
      });
      return result;
    } catch (err) {
      console.error('Error in debugDriverData:', err);
      throw err;
    }
  }, [fetchWithAuth]);

  // Payment Info API functions
  const submitPaymentInfo = useCallback(async (flowEntityId, paymentData) => {
    try {
      const result = await fetchWithAuth('submitPaymentInfo', {
        method: 'POST',
        body: {
          flowEntityId,
          ...paymentData
        }
      });
      return result;
    } catch (err) {
      console.error('Error in submitPaymentInfo:', err);
      throw err;
    }
  }, [fetchWithAuth]);

  const getPaymentInfo = useCallback(async (flowEntityId) => {
    try {
      const result = await fetchWithAuth(`getPaymentInfo?flowEntityId=${encodeURIComponent(flowEntityId)}`);
      return result;
    } catch (err) {
      console.error('Error in getPaymentInfo:', err);
      throw err;
    }
  }, [fetchWithAuth]);

  // KYC submission function
  const submitKYC = useCallback(async (carId, kycData) => {
    try {
      const result = await fetchWithAuth('submitKYC', {
        method: 'POST',
        body: {
          carId,
          ...kycData
        }
      });
      return result;
    } catch (err) {
      console.error('Error in submitKYC:', err);
      throw err;
    }
  }, [fetchWithAuth]);

  // KYC approval/rejection function
  const approveRejectKYC = useCallback(async (carId, action, comments,dealerId) => {
    try {
      const result = await fetchWithAuth('approveRejectKYC', {
        method: 'POST',
        body: {
          carId,
          action,
          comments,
          dealerId
        }
      });
      return result;
    } catch (err) {
      console.error('Error in approveRejectKYC:', err);
      throw err;
    }
  }, [fetchWithAuth]);

  const uploadNOCDocuments = useCallback(async (carId, nocData) => {
    try {
      const result = await fetchWithAuth('uploadNOCDocuments', {
        method: 'POST',
        body: {
          carId,
          nocData
        }
      });
      return result;
    } catch (err) {
      console.error('Error in uploadNOCDocuments:', err);
      throw err;
    }
  }, [fetchWithAuth]);

  const submitRC = useCallback(async (carId, rcData) => {
    try {
      const result = await fetchWithAuth('submitRC', {
        method: 'POST',
        body: {
          carId,
          ...rcData
        }
      });
      return result;
    } catch (err) {
      console.error('Error in submitRC:', err);
      throw err;
    }
  }, [fetchWithAuth]);

  const approveRejectRC = useCallback(async (carId, action, comments) => {
    try {
      const result = await fetchWithAuth('approveRejectRC', {
        method: 'POST',
        body: {
          carId,
          action,
          comments
        }
      });
      return result;
    } catch (err) {
      console.error('Error in approveRejectRC:', err);
      throw err;
    }
  }, [fetchWithAuth]);

  const getDepositRefundPendingItems = useCallback(async () => {
    try {
      const result = await fetchWithAuth('getDepositRefundPendingItems', {
        method: 'GET'
      });
      return result;
    } catch (err) {
      console.error('Error in getDepositRefundPendingItems:', err);
      throw err;
    }
  }, [fetchWithAuth]);

  const updateDepositRefundStatus = useCallback(async (flowEntityId, status, comments, attachments) => {
    try {
      const result = await fetchWithAuth('updateDepositRefundStatus', {
        method: 'POST',
        body: {
          flowEntityId,
          status,
          comments,
          attachments
        }
      });
      return result;
    } catch (err) {
      console.error('Error in updateDepositRefundStatus:', err);
      throw err;
    }
  }, [fetchWithAuth]);

  const submitPaymentVerification = useCallback(async (flowEntityId, verifiedPaymentData, comment) => {
    try {
      const result = await fetchWithAuth('submitPaymentVerification', {
        method: 'POST',
        body: JSON.stringify({
          flowEntityId,
          verifiedPaymentData,
          comment
        })
      });
      return result;
    } catch (err) {
      console.error('Error in submitPaymentVerification:', err);
      throw err;
    }
  }, [fetchWithAuth]);

  const rejectPayment = useCallback(async (flowEntityId, comment) => {
    try {
      const result = await fetchWithAuth('rejectPayment', {
        method: 'POST',
        body: JSON.stringify({
          flowEntityId,
          comment
        })
      });
      return result;
    } catch (err) {
      console.error('Error in rejectPayment:', err);
      throw err;
    }
  }, [fetchWithAuth]);

  return {
    fetchWithAuth,
    sendDeliveryReminder,
    sendKycReminder,
    sendAuctionPaymentRequest,
    sendCarPickupReminder,
    sendAuctionCloseAlert,
    sendInspectionReminder,
    sendEvaluationGatePassReminder,
    // REMOVED: SendOTPDealer - replaced by new OTP module
    // SendOTPDealer,
    LoginDealer,
    loading,
    error,
    getUsers,
    DealerContract,
    RegisterDealer,
    getDealers,
    getOrganizations,
    getRoles,
    getCities,
    getBDMCityMappings,
    createBDMCityMapping,
    updateBDMCityMapping,
    deleteBDMCityMapping,
    createUser,
    uploadDocuments,
    createDealer,
    createDealerInfo,
    updateUser,
    deleteUser,
    createOrganization,
    updateOrganization,
    deleteOrganization,
    updateRole,
    createRole,
    createOTPLoginAccess,
    getAuctions,
    updateAuction,
    deleteAuction,
    updateCar,
    deleteCar,
    uploadAuctions,
    getMakeModels,
    getShortCodeMappings,
    // Old notification functions removed - use MSG91 functions instead
    getMSG91EmailTemplates,
    getMSG91WhatsAppTemplates,
    getMSG91WhatsAppFlows,
    getMSG91AccountInfo,
    getMSG91Balance,
    testMSG91Connectivity,
    validateMSG91ApiKey,
    getMSG91TemplateCategories,
    getMSG91AccountDetails,
    getMSG91TemplatesByID,
    getAllMSG91Services,
    getMSG91EmailTemplateDetails,
    getDealerCityMappings,
    createDealerCityMapping,
    updateDealerCityMapping,
    deleteDealerCityMapping,
    getDealerCarsByCity,
    getAllDriversForOrg,
    getCars,
    getGatepasses,
    getGatepassesForBDM,
    getBDMData,
    getBDMDashboardMetricsOptimized,
    getBDMCarsByStatusOptimized,
    updateGatepassStatus,
    updateCarWorkflowState,
    getBDMDashboardMetrics,
    getCarsSoldCount,
    getActiveBidsCount,
    getCompletedPaymentsCount,
    getKYCVerifiedCount,
    getNOCApprovedCount,
    getCarsOwnCount,
    // Driver management
    getDrivers,
    createDriver,
    updateDriver,
    deleteDriver,
    // Supplier management
    getSuppliers,
    createSupplier,
    updateSupplier,
    deleteSupplier,
    uploadSupplierLogo,
    submitSupplier,
    importSuppliers,
    // Sales Persons management
    getSalesPersons,
    uploadSalesPersons,
    deleteSalesPerson,
    // Gatepass management
    createGatepass,
    shareEvalLink,
    generateObfuscatedEvaluationLink,
    getEvaluationLinkData,
    getDriverByPhone,
    createDriverUserAccount,
    getDriverCarsByYard,
    debugDriverData,
    // Favorites management
    getFavorites,
    addFavorite,
    removeFavorite,
    getAllFavoritesForUser,
    // Document management
    getAllDocuments,
    getDealerFlowEntities,
    getDocumentById,
    updateDocument,
    // Bid management
    getBidCount,
    getAvailableCarsForBidding,
    getBids,
    submitBidWithLimit,
    saveBidData,
    getBidData,
    // Payment and notification
    getPaymentNotifications,
    savePaymentNotifications,
    // Yard and car management
    getMyCarsByYard,
    requestGatepassForYard,
    addToMyCars,
    submitYard,
    updateYard,
    deleteYard,
    getYards,
    importYards,
    
    // New consolidated dealer home data API
    getDealerHomeData,
    
    // Inspection management
    generateInspectionLink: useCallback(async (gatepassId) => {
      try {
        const result = await fetchWithAuth('generateInspectionLink', {
          method: 'POST',
          body: JSON.stringify({ gatepassId })
        });
        return result;
      } catch (err) {
        console.error('Error in generateInspectionLink:', err);
        throw err;
      }
    }, [fetchWithAuth]),
    
    uploadInspectionImagesViaLink: useCallback(async (inspectionId, images, notes) => {
      try {
        const result = await fetchWithAuth('uploadInspectionImagesViaLink', {
          method: 'POST',
          body: JSON.stringify({ inspectionId, images, notes })
        });
        return result;
      } catch (err) {
        console.error('Error in uploadInspectionImagesViaLink:', err);
        throw err;
      }
    }, [fetchWithAuth]),
    
    getInspectionData: useCallback(async (inspectionId) => {
      try {
        const result = await fetchWithAuth(`getInspectionData?inspectionId=${inspectionId}`);
        return result;
      } catch (err) {
        console.error('Error in getInspectionData:', err);
        throw err;
      }
    }, [fetchWithAuth]),
    // Debug and utility
    clearTestBids,
    debugGatepasses,
    // Car management for AuctionsPage
    updateCarFlat,
    deleteCarFlat,
    updateCarsBulk,
    bulkUpdateCarsWithFlowEntities,
    updateCarsViaExcel,
    exportAuctions,
    getDealerEvaluationCars,
    getDealerPlaceBidsCars,
    getDealerPaymentCars,
    getBDMPaymentCars,
    getFinanceApprovalData,
    getHeadFinanceApprovalData,
    getBDMEvaluationCars,
    getBDMPlaceBidsCars,
    getAuctionhelperData,
    awardBidWinner,
    declineBid,
    
    // MSG91 OTP Authentication APIs (Generic - replaces Firebase OTP)
    sendOTP: useCallback(async ({ phoneNumber }) => {
      try {
        const result = await fetchWithAuth('sendOTP', {
          method: 'POST',
          body: JSON.stringify({ phoneNumber })
        });
        return result;
      } catch (err) {
        console.error('Error in sendOTP:', err);
        throw err;
      }
    }, [fetchWithAuth]),
    
    verifyOTP: useCallback(async ({ otp, otpToken }) => {
      try {
        const result = await fetchWithAuth('verifyOTP', {
          method: 'POST',
          body: JSON.stringify({ otp, otpToken })
        });
        return result;
      } catch (err) {
        console.error('Error in verifyOTP:', err);
        throw err;
      }
    }, [fetchWithAuth]),
    
    getEvaluationYards: useCallback(async () => {
      try {
        const result = await fetchWithAuth('getEvaluationYards');
        return result;
      } catch (err) {
        console.error('Error in getEvaluationYards:', err);
        throw err;
      }
    }, [fetchWithAuth]),
    
    getEvaluationCarsForYard: useCallback(async ({ yardId }) => {
      try {
        const result = await fetchWithAuth(`getEvaluationCarsForYard?yardId=${yardId}`);
        return result;
      } catch (err) {
        console.error('Error in getEvaluationCarsForYard:', err);
        throw err;
      }
    }, [fetchWithAuth]),
    
    getCarDetails: useCallback(async ({ carId, flowEntityId }) => {
      try {
        let endpoint = 'getCarDetails';
        if (flowEntityId) {
          endpoint += `?flowEntityId=${flowEntityId}`;
        } else if (carId) {
          endpoint += `?carId=${carId}`;
        } else {
          throw new Error('Either carId or flowEntityId is required');
        }
        const result = await fetchWithAuth(endpoint);
        return result;
      } catch (err) {
        console.error('Error in getCarDetails:', err);
        throw err;
      }
    }, [fetchWithAuth]),
    
    updateCarEvaluation: useCallback(async ({ carId, flowEntityId, evaluationImages }) => {
      try {
        const result = await fetchWithAuth('updateCarEvaluation', {
          method: 'POST',
          body: JSON.stringify({ carId, flowEntityId, evaluationImages })
        });
        return result;
      } catch (err) {
        console.error('Error in updateCarEvaluation:', err);
        throw err;
      }
    }, [fetchWithAuth]),
    
    submitEvaluation: useCallback(async ({ carId, flowEntityId, evaluationImages }) => {
      try {
        const result = await fetchWithAuth('submitEvaluation', {
          method: 'POST',
          body: JSON.stringify({ carId, flowEntityId, evaluationImages })
        });
        return result;
      } catch (err) {
        console.error('Error in submitEvaluation:', err);
        throw err;
      }
    }, [fetchWithAuth]),
    
    
    updateCarWorkflowStatus: useCallback(async ({ carId, status }) => {
      try {
        const result = await fetchWithAuth('updateCarWorkflowStatus', {
          method: 'POST',
          body: JSON.stringify({ carId, status })
        });
        return result;
      } catch (err) {
        console.error('Error in updateCarWorkflowStatus:', err);
        throw err;
      }
    }, [fetchWithAuth]),

    placeBidForCar: useCallback(async ({ carId, flowEntityId, bidAmount }) => {
      try {
        const result = await fetchWithAuth('placeBidForCar', {
          method: 'POST',
          body: JSON.stringify({ carId, flowEntityId, bidAmount })
        });
        return result;
      } catch (err) {
        console.error('Error in placeBidForCar:', err);
        throw err;
      }
    }, [fetchWithAuth]),

    getDealerDeliveryCars: useCallback(async () => {
      try {
        const result = await fetchWithAuth('getDealerDeliveryCars');
        return result;
      } catch (err) {
        console.error('Error in getDealerDeliveryCars:', err);
        throw err;
      }
    }, [fetchWithAuth]),

    getBDMDeliveryCars: useCallback(async () => {
      try {
        const result = await fetchWithAuth('getBDMDeliveryCars');
        return result;
      } catch (err) {
        console.error('Error in getBDMDeliveryCars:', err);
        throw err;
      }
    }, [fetchWithAuth]),

    createDeliveryGatepass: useCallback(async ({ carId, auctionId, driverId, driverName, driverPhone, driverAddress, notes }) => {
      try {
        const result = await fetchWithAuth('createDeliveryGatepass', {
          method: 'POST',
          body: JSON.stringify({ carId, auctionId, driverId, driverName, driverPhone, driverAddress, notes })
        });
        return result;
      } catch (err) {
        console.error('Error in createDeliveryGatepass:', err);
        throw err;
      }
    }, [fetchWithAuth]),

    approveDeliveryGatepass: useCallback(async ({ carId, auctionId, dealerId, deliveryGatepassId }) => {
      try {
        const result = await fetchWithAuth('approveDeliveryGatepass', {
          method: 'POST',
          body: JSON.stringify({ carId, auctionId, dealerId, deliveryGatepassId })
        });
        return result;
      } catch (err) {
        console.error('Error in approveDeliveryGatepass:', err);
        throw err;
      }
    }, [fetchWithAuth]),

    rejectDeliveryGatepass: useCallback(async ({ carId, auctionId, dealerId, deliveryGatepassId, rejectionReason }) => {
      try {
        const result = await fetchWithAuth('rejectDeliveryGatepass', {
          method: 'POST',
          body: JSON.stringify({ carId, auctionId, dealerId, deliveryGatepassId, rejectionReason })
        });
        return result;
      } catch (err) {
        console.error('Error in rejectDeliveryGatepass:', err);
        throw err;
      }
    }, [fetchWithAuth]),

    generateDeliveryLink: useCallback(async ({ carId, auctionId }) => {
      try {
        const result = await fetchWithAuth('generateDeliveryLink', {
          method: 'POST',
          body: JSON.stringify({ carId, auctionId })
        });
        return result;
      } catch (err) {
        console.error('Error in generateDeliveryLink:', err);
        throw err;
      }
    }, [fetchWithAuth]),

    getDeliveryLinkData: useCallback(async (deliveryLinkId) => {
      try {
        const result = await fetchWithAuth(`getDeliveryLinkData?deliveryLinkId=${deliveryLinkId}`, {
          method: 'GET'
        });
        return result;
      } catch (err) {
        console.error('Error in getDeliveryLinkData:', err);
        throw err;
      }
    }, [fetchWithAuth]),

    updateDeliveryPhotos: useCallback(async ({ deliveryLinkId, photos }) => {
      try {
        const result = await fetchWithAuth('updateDeliveryPhotos', {
          method: 'POST',
          body: JSON.stringify({ deliveryLinkId, photos })
        });
        return result;
      } catch (err) {
        console.error('Error in updateDeliveryPhotos:', err);
        throw err;
      }
    }, [fetchWithAuth]),

    confirmDelivery: useCallback(async ({ flowEntityId }) => {
      try {
        console.log('🔍 confirmDelivery useApi - flowEntityId:', flowEntityId);
        const bodyData = JSON.stringify({ flowEntityId });
        console.log('🔍 confirmDelivery useApi - bodyData:', bodyData);
        
        const result = await fetchWithAuth('confirmDelivery', {
          method: 'POST',
          body: bodyData
        });
        return result;
      } catch (err) {
        console.error('Error in confirmDelivery:', err);
        throw err;
      }
    }, [fetchWithAuth]),

    generateDeliveryOTP: useCallback(async ({ deliveryLinkId, driverPhone }) => {
      try {
        const result = await fetchWithAuth('generateDeliveryOTP', {
          method: 'POST',
          body: JSON.stringify({ deliveryLinkId, driverPhone })
        });
        return result;
      } catch (err) {
        console.error('Error in generateDeliveryOTP:', err);
        throw err;
      }
    }, [fetchWithAuth]),

    verifyDeliveryOTP: useCallback(async ({ deliveryLinkId, otp }) => {
      try {
        const result = await fetchWithAuth('verifyDeliveryOTP', {
          method: 'POST',
          body: JSON.stringify({ deliveryLinkId, otp })
        });
        return result;
      } catch (err) {
        console.error('Error in verifyDeliveryOTP:', err);
        throw err;
      }
    }, [fetchWithAuth]),

    uploadDeliveryPhotos: useCallback(async ({ deliveryLinkId, sessionToken, photos }) => {
      try {
        const result = await fetchWithAuth('uploadDeliveryPhotos', {
          method: 'POST',
          body: JSON.stringify({ deliveryLinkId, sessionToken, photos })
        });
        return result;
      } catch (err) {
        console.error('Error in uploadDeliveryPhotos:', err);
        throw err;
      }
    }, [fetchWithAuth]),

    getDealerNOCCars: useCallback(async () => {
      try {
        const result = await fetchWithAuth('getDealerNOCCars');
        return result;
      } catch (err) {
        console.error('Error in getDealerNOCCars:', err);
        throw err;
      }
    }, [fetchWithAuth]),

    getBDMNOCCars: useCallback(async () => {
      try {
        const result = await fetchWithAuth('getBDMNOCCars');
        return result;
      } catch (err) {
        console.error('Error in getBDMNOCCars:', err);
        throw err;
      }
    }, [fetchWithAuth]),

    updateFlowEntity: useCallback(async ({ flowEntityId, updateData }) => {
      try {
        console.log('🔍 updateFlowEntity called with:', { flowEntityId, updateData });
        const result = await fetchWithAuth('updateFlowEntity', {
          method: 'POST',
          body: JSON.stringify({ flowEntityId, updateData })
        });
        console.log('🔍 updateFlowEntity result:', result);
        return result;
      } catch (err) {
        console.error('Error in updateFlowEntity:', err);
        throw err;
      }
    }, [fetchWithAuth]),

    // Steering Wheel Management
    getSteeringWheels: useCallback(async () => {
      try {
        const result = await apiService.getSteeringWheels();
        return result;
      } catch (err) {
        console.error('Error in getSteeringWheels:', err);
        throw err;
      }
    }, []),

    createSteeringWheel: useCallback(async (data) => {
      try {
        const result = await apiService.createSteeringWheel(data);
        return result;
      } catch (err) {
        console.error('Error in createSteeringWheel:', err);
        throw err;
      }
    }, []),

    updateSteeringWheel: useCallback(async (data) => {
      try {
        const result = await apiService.updateSteeringWheel(data);
        return result;
      } catch (err) {
        console.error('Error in updateSteeringWheel:', err);
        throw err;
      }
    }, []),

    deleteSteeringWheel: useCallback(async (data) => {
      try {
        const result = await apiService.deleteSteeringWheel(data);
        return result;
      } catch (err) {
        console.error('Error in deleteSteeringWheel:', err);
        throw err;
      }
    }, []),

    serveSteeringWheelImage: useCallback(async (params) => {
      try {
        const result = await apiService.serveSteeringWheelImage(params);
        return result;
      } catch (err) {
        console.error('Error in serveSteeringWheelImage:', err);
        throw err;
      }
    }, []),

    uploadSteeringWheelImage: useCallback(async (data) => {
      try {
        const result = await apiService.uploadSteeringWheelImage(data);
        return result;
      } catch (err) {
        console.error('Error in uploadSteeringWheelImage:', err);
        throw err;
      }
    }, []),

    deleteSteeringWheelImage: useCallback(async (data) => {
      try {
        const result = await apiService.deleteSteeringWheelImage(data);
        return result;
      } catch (err) {
        console.error('Error in deleteSteeringWheelImage:', err);
        throw err;
      }
    }, []),
    
    // File Upload Functions
    // 
    // Usage Examples:
    // 
    // 1. Upload evaluation image:
    // const result = await uploadFile(imageFile, 'evaluations', 'front_face.jpg', { carId: '123', angle: 'front' });
    // 
    // 2. Upload driver photo:
    // const result = await uploadFile(photoFile, 'drivers', 'driver_photo.jpg', { driverId: '456' });
    // 
    // 3. Upload inspection image:
    // const result = await uploadFile(inspectionFile, 'inspections', 'inspection.jpg', { inspectionId: '789' });
    // 
    // Returns: { success: true, filePath, publicUrl, fileName, uploadedBy, uploadedAt }
    uploadFile: useCallback(async (file, folder, fileName, metadata = {}) => {
      try {
        console.log('🔍 uploadFile called with:', { file, folder, fileName, metadata });
        console.log('🔍 File type:', file.type, 'File size:', file.size, 'File name:', file.name);
        
        // Convert file to base64 for transmission
        const base64File = await fileToBase64(file);
        console.log('🔍 Base64 file length:', base64File.length);
        console.log('🔍 Base64 file preview:', base64File.substring(0, 100) + '...');
        
        const requestBody = {
          file: base64File,
          folder,
          fileName,
          metadata: {
            contentType: file.type,
            originalName: file.name,
            size: file.size,
            ...metadata
          }
        };
        
        console.log('🔍 Request body keys:', Object.keys(requestBody));
        console.log('🔍 Request body metadata:', requestBody.metadata);
        
        const result = await fetchWithAuth('uploadFile', {
          method: 'POST',
          body: JSON.stringify(requestBody)
        });
        
        console.log('🔍 Upload result:', result);
        return result;
      } catch (err) {
        console.error('Error in uploadFile:', err);
        throw err;
      }
    }, [fetchWithAuth]),
    
    deleteFile: useCallback(async (filePath) => {
      try {
        const result = await fetchWithAuth('deleteFile', {
          method: 'POST',
          body: JSON.stringify({ filePath })
        });
        
        return result;
      } catch (err) {
        console.error('Error in deleteFile:', err);
        throw err;
      }
    }, [fetchWithAuth]),
    
    getFileMetadata: useCallback(async (filePath) => {
      try {
        const result = await fetchWithAuth(`getFileMetadata?filePath=${encodeURIComponent(filePath)}`);
        
        return result;
      } catch (err) {
        console.error('Error in getFileMetadata:', err);
        throw err;
      }
    }, [fetchWithAuth]),

    // Database Management Functions
    exportDatabase: useCallback(async () => {
      try {
        const result = await fetchWithAuth('exportDatabase');
        return result;
      } catch (err) {
        console.error('Error in exportDatabase:', err);
        throw err;
      }
    }, [fetchWithAuth]),

    importDatabase: useCallback(async (importData) => {
      try {
        const result = await fetchWithAuth('importDatabase', {
          method: 'POST',
          body: JSON.stringify({ importData })
        });
        return result;
      } catch (err) {
        console.error('Error in importDatabase:', err);
        throw err;
      }
    }, [fetchWithAuth]),

    truncateDatabase: useCallback(async () => {
      try {
        const result = await fetchWithAuth('truncateDatabase', {
          method: 'POST'
        });
        return result;
      } catch (err) {
        console.error('Error in truncateDatabase:', err);
        throw err;
      }
    }, [fetchWithAuth]),

    // Payment Info functions
    submitPaymentInfo,
    submitKYC,
    approveRejectKYC,
    uploadNOCDocuments,
    submitRC,
    approveRejectRC,
    getDepositRefundPendingItems,
    updateDepositRefundStatus,
    getPaymentInfo,
    submitPaymentVerification,
    rejectPayment,

    // MSG91 Notification Functions
    msg91SendEmail: useCallback(async (data) => {
      try {
        const result = await fetchWithAuth('msg91SendEmail', {
          method: 'POST',
          body: JSON.stringify(data)
        });
        return result;
      } catch (err) {
        console.error('Error in msg91SendEmail:', err);
        throw err;
      }
    }, [fetchWithAuth]),

    msg91SendWhatsApp: useCallback(async (data) => {
      try {
        const result = await fetchWithAuth('msg91SendWhatsApp', {
          method: 'POST',
          body: JSON.stringify(data)
        });
        return result;
      } catch (err) {
        console.error('Error in msg91SendWhatsApp:', err);
        throw err;
      }
    }, [fetchWithAuth]),

    msg91SendBulkWhatsApp: useCallback(async (data) => {
      try {
        const result = await fetchWithAuth('msg91SendBulkWhatsApp', {
          method: 'POST',
          body: JSON.stringify(data)
        });
        return result;
      } catch (err) {
        console.error('Error in msg91SendBulkWhatsApp:', err);
        throw err;
      }
    }, [fetchWithAuth]),

    msg91SendSMS: useCallback(async (data) => {
      try {
        const result = await fetchWithAuth('msg91SendSMS', {
          method: 'POST',
          body: JSON.stringify(data)
        });
        return result;
      } catch (err) {
        console.error('Error in msg91SendSMS:', err);
        throw err;
      }
    }, [fetchWithAuth]),

    msg91GetBalance: useCallback(async () => {
      try {
        const result = await fetchWithAuth('msg91GetBalance');
        return result;
      } catch (err) {
        console.error('Error in msg91GetBalance:', err);
        throw err;
      }
    }, [fetchWithAuth]),

    msg91GetTemplates: useCallback(async (type = 'all') => {
      try {
        const result = await fetchWithAuth(`msg91GetTemplates?type=${type}`);
        return result;
      } catch (err) {
        console.error('Error in msg91GetTemplates:', err);
        throw err;
      }
    }, [fetchWithAuth]),

    msg91TestConnection: useCallback(async () => {
      try {
        const result = await fetchWithAuth('msg91TestConnection');
        return result;
      } catch (err) {
        console.error('Error in msg91TestConnection:', err);
        throw err;
      }
    }, [fetchWithAuth]),

    msg91Configure: useCallback(async (config) => {
      try {
        const result = await fetchWithAuth('msg91Configure', {
          method: 'POST',
          body: JSON.stringify(config)
        });
        return result;
      } catch (err) {
        console.error('Error in msg91Configure:', err);
        throw err;
      }
    }, [fetchWithAuth]),

    msg91GetLogs: useCallback(async (options = {}) => {
      try {
        const params = new URLSearchParams();
        if (options.limit) params.append('limit', options.limit);
        if (options.channel) params.append('channel', options.channel);
        if (options.success !== undefined) params.append('success', options.success);
        
        const queryString = params.toString();
        const result = await fetchWithAuth(`msg91GetLogs${queryString ? '?' + queryString : ''}`);
        return result;
      } catch (err) {
        console.error('Error in msg91GetLogs:', err);
        throw err;
      }
    }, [fetchWithAuth]),

    // MSG91 Email Template Management Functions
    msg91CreateEmailTemplate: useCallback(async (data) => {
      try {
        const result = await fetchWithAuth('msg91CreateEmailTemplate', {
          method: 'POST',
          body: JSON.stringify(data)
        });
        return result;
      } catch (err) {
        console.error('Error in msg91CreateEmailTemplate:', err);
        throw err;
      }
    }, [fetchWithAuth]),

    msg91ValidateEmail: useCallback(async (data) => {
      try {
        const result = await fetchWithAuth('msg91ValidateEmail', {
          method: 'POST',
          body: JSON.stringify(data)
        });
        return result;
      } catch (err) {
        console.error('Error in msg91ValidateEmail:', err);
        throw err;
      }
    }, [fetchWithAuth]),

    msg91InlineCSSTemplate: useCallback(async (data) => {
      try {
        const result = await fetchWithAuth('msg91InlineCSSTemplate', {
          method: 'POST',
          body: JSON.stringify(data)
        });
        return result;
      } catch (err) {
        console.error('Error in msg91InlineCSSTemplate:', err);
        throw err;
      }
    }, [fetchWithAuth]),

    // MSG91 WhatsApp Delivery Status
    msg91CheckWhatsAppStatus: useCallback(async (data) => {
      try {
        const result = await fetchWithAuth('msg91CheckWhatsAppStatus', {
          method: 'POST',
          body: JSON.stringify(data)
        });
        return result;
      } catch (err) {
        console.error('Error in msg91CheckWhatsAppStatus:', err);
        throw err;
      }
    }, [fetchWithAuth]),

    // MSG91 Connectivity Test
    msg91TestConnectivity: useCallback(async () => {
      try {
        const result = await fetchWithAuth('msg91TestConnectivity', {
          method: 'POST'
        });
        return result;
      } catch (err) {
        console.error('Error in msg91TestConnectivity:', err);
        throw err;
      }
    }, [fetchWithAuth]),

    // MSG91 Get Configuration
    msg91GetConfig: useCallback(async () => {
      try {
        const result = await fetchWithAuth('msg91GetConfig', {
          method: 'GET'
        });
        return result;
      } catch (err) {
        console.error('Error in msg91GetConfig:', err);
        throw err;
      }
    }, [fetchWithAuth]),

    // Dealer Banking Details
    updateDealerBankingDetails,

    // Quote Admin Functions
    getQuoteAdminCars: useCallback(async () => {
      try {
        const result = await fetchWithAuth('getQuoteAdminCars');
        return result;
      } catch (err) {
        console.error('Error in getQuoteAdminCars:', err);
        throw err;
      }
    }, [fetchWithAuth]),

    updateQuoteOfferPrice: useCallback(async ({ carId, offer_amount }) => {
      try {
        const result = await fetchWithAuth('updateQuoteOfferPrice', {
          method: 'POST',
          body: JSON.stringify({ carId, offer_amount })
        });
        return result;
      } catch (err) {
        console.error('Error in updateQuoteOfferPrice:', err);
        throw err;
      }
    }, [fetchWithAuth]),

    publishCar: useCallback(async ({ carId }) => {
      try {
        const result = await fetchWithAuth('publishCar', {
          method: 'POST',
          body: JSON.stringify({ carId })
        });
        return result;
      } catch (err) {
        console.error('Error in publishCar:', err);
        throw err;
      }
    }, [fetchWithAuth]),

    sendQuote: useCallback(async ({ carId }) => {
      try {
        const result = await fetchWithAuth('sendQuote', {
          method: 'POST',
          body: JSON.stringify({ carId })
        });
        return result;
      } catch (err) {
        console.error('Error in sendQuote:', err);
        throw err;
      }
    }, [fetchWithAuth])
  };
} 